import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'connected-react-router'

import rootReducer from './reducers'
import { submitting } from './middleware/submitting'
import { airports } from './middleware/airports'
import { content } from './middleware/content'
import { queryStringPrefill } from './middleware/queryStringPrefill'
import { airportRoutes } from './middleware/airportRoutes'
import history from './config/history'

const initialState = {}
const enhancers = []
const middleware = [
  routerMiddleware(history),
  submitting,
  airports,
  content,
  queryStringPrefill,
  airportRoutes,
]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)
const store = createStore(rootReducer(history), initialState, composedEnhancers)

export default store
